import moment from 'moment';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Column, Row} from '../../../components/layout';
import colors from '../../../util/colors';
import {strings} from '../../../util/strings';
import {UtilizationItem} from '../UtilizationHistory';
import * as fonts from '../../../util/fonts';
import './styles.scss';
import 'moment/locale/sr';

export interface UtilizationListItemProps {
  utilizationItem: UtilizationItem;
  labels: typeof strings.pt.refund;
  buStyles: any;
  language: any;
  userLanguage: any;
}
function UtilizationListItem({
  labels,
  utilizationItem,
  buStyles,
  language,
  userLanguage,
}: UtilizationListItemProps) {
  const defineLang = () => {
    const dateLanguage =
      (language || userLanguage)?.split('-')[0] === 'rs'
        ? 'sr'
        : (language || userLanguage)?.split('-')[0];
    return dateLanguage;
  };

  return (
    <>
      <Row>
        <Column
          className="reimbursement-history-declarationlist-column1"
          style={{...fonts.MM}}>
          <strong>
            {moment(utilizationItem.dosFrom)
              .locale(defineLang())
              .format('DD MMM')
              .toUpperCase()}
          </strong>
          {new Date(utilizationItem.dosFrom).getFullYear()}
        </Column>
        <Column className="reimbursement-history-declarationlist-column2">
          <strong
            style={{
              ...fonts.MM,
              ...fonts.Bold,
              color: buStyles?.primaryColor || colors.blue,
            }}>
            {utilizationItem.catName}
          </strong>
          {utilizationItem.clinicName}
        </Column>
        <Column className="reimbursement-history-declarationlist-column3">
          {utilizationItem.submittedGroup?.toUpperCase().includes('MEMB') ? (
            <strong className="utilization-list-item-submittedgroup">
              {labels?.refundDetail_sendByMe}
            </strong>
          ) : (
            ''
          )}
        </Column>
      </Row>
      <div className="reimbursement-history-declarationlist-line"></div>
    </>
  );
}

const mapStateToProps = ({strings, globalStyles, language, user}: any) => ({
  labels: strings.value.pt.refund,
  buStyles: globalStyles.value,
  language: language.value,
  userLanguage: user.value.language,
});

export default compose(connect(mapStateToProps)(UtilizationListItem));
